import { initI18n } from '@repo/shared/i18n';

import en from './locales/en/teams.json';
import es from './locales/es/teams.json';
import hi from './locales/hi/teams.json';
import ar from './locales/ar/teams.json';

export default initI18n('teams', { en, es, hi, ar });
